'use strict';

var base = require('../product/base');
var focusHelper = require('base/components/focus');
var quantitySelector = require('../product/quantitySelector');
var location = window.location;
var cartInventoryValidator = require('./cartInventoryValidator');
var cartTotals = require('./cartTotals');
var analyticsHelper = require('../util/analyticsHelper');

var quantityLimitBlocked = false;

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

/**
 * Checks whether the basket is valid. if invalid displays error message and disables
 * checkout button
 * @param {Object} data - AJAX response from the server
 */
function validateBasket(data) {
    quantityLimitBlocked = data.hasQuantityLimitViolations === true;
    if (data.valid.error) {
        if (data.valid.message) {

            var closeIconUrl = $('.minicart-footer .cart-error').data('icon-close-url');
            var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error fade show" role="alert">'
                + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
                + '<img src="' + closeIconUrl + '" alt="Close" />'
                + '</button>'
                + data.valid.message
                + '</div>';

            $('.minicart-footer .cart-error').append(errorHtml);
        } else if (!data.valid.hasAvailabilityError){
            $('.cart').empty().append('<div class="row"> '
                + '<div class="col-12 text-center"> '
                + '<h1>' + data.resources.emptyCartMsg + '</h1> '
                + '</div> '
                + '</div>');
            $('.number-of-items').empty().append(data.resources.numberOfItems);
            $('.minicart-quantity').empty().append(data.numItems);
            $('.minicart-link').attr({
                'aria-label': data.resources.minicartCountOfItems,
                title: data.resources.minicartCountOfItems
            });
            $('.minicart .popover').empty();
            $('.minicart .popover').removeClass('show');
        }

        $('.checkout-btn').addClass('disabled');
    } else if (data.hasQuantityLimitViolations) {
        $('.checkout-btn').addClass('disabled');
    } else {
        var isShippingBlocked = $('.checkout-btn').data('shipping-blocked') === true;
        if (!isShippingBlocked) {
            $('.checkout-btn').removeClass('disabled');
        }
    }
}

/**
 * Re-asserts the checkout button block caused by quantity limit violations.
 * Runs when the async inventory validation (validateCartInventory) completes,
 * whose enableCheckoutBegin() only knows about availability and could otherwise
 * unblock a checkout blocked by quantity limits.
 */
function reassertQuantityLimitBlock() {
    if (quantityLimitBlocked) {
        $('.checkout-btn').addClass('disabled');
    }
}

/**
 * Reconciles the Quantity Limit DOM with the latest server response.
 * The response is the single source of truth: when a line item no longer
 * exceeds its limit, the previously server-rendered Quantity Limit markup for
 * that item is removed; the global block message and the blocked flag are
 * removed only when no violations remain.
 * @param {Object} data - AJAX response from Cart-UpdateQuantity
 */
function updateQuantityLimitState(data) {
    if (data && data.items) {
        data.items.forEach(function (item) {
            var $productCard = $('.card.product-info.uuid-' + item.UUID);
            if (!item.quantityLimitError) {
                if ($productCard.length) {
                    $productCard.removeClass('quantity-limit-error');
                    $productCard.find('.quantity-limit-message, .quantity-limit-message-mobile').remove();
                }
            } else if ($productCard.length && item.quantityLimitReduceMessage) {
                $productCard.addClass('quantity-limit-error');

                var existingMessage = $productCard.find('.quantity-limit-message:not(.quantity-limit-message-mobile)');
                var existingMessageMobile = $productCard.find('.quantity-limit-message-mobile');

                if (existingMessage.length) {
                    existingMessage.find('.error-text').html(item.quantityLimitReduceMessage);
                } else {
                    var errorIconSrc = $('.checkout-button').data('icon-url');
                    $productCard.find('.line-item-header').append(
                        '<div class="quantity-limit-message">'
                        + '<img class="error-icon" src="' + errorIconSrc + '" alt="error" />'
                        + '<span class="error-text">' + item.quantityLimitReduceMessage + '</span>'
                        + '</div>'
                    );
                }

                if (existingMessageMobile.length) {
                    existingMessageMobile.find('.error-text').html(item.quantityLimitReduceMessage);
                } else {
                    var mobileIconSrc = $('.checkout-button').data('icon-url');
                    $productCard.find('.item-image').after(
                        '<div class="quantity-limit-message quantity-limit-message-mobile">'
                        + '<img class="error-icon" src="' + mobileIconSrc + '" alt="error" />'
                        + '<span class="error-text">' + item.quantityLimitReduceMessage + '</span>'
                        + '</div>'
                    );
                }
            }
        });
    }

    if (data && data.hasQuantityLimitViolations) {
        var $blockMessage = $('.quantity-limit-block-message');
        if (!$blockMessage.length) {
            var blockIconSrc = $('.checkout-button').data('icon-url');
            $('.checkout-button').prepend(
                '<div class="quantity-limit-block-message">'
                + '<img class="error-icon" src="' + blockIconSrc + '" alt="error" />'
                + '<span class="error-text">' + data.quantityLimitViolationMessage + '</span>'
                + '</div>'
            );
        } else {
            $blockMessage.find('.error-text').html(data.quantityLimitViolationMessage);
        }
        $('.checkout-btn').data('quantity-limit-blocked', true);
    } else if (data && data.hasQuantityLimitViolations === false) {
        $('.quantity-limit-block-message').remove();
        $('.checkout-btn').data('quantity-limit-blocked', false);
    }
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 * @param {jQuery} errorContainer - Container where the message can be optionally inserted into
 */
function createErrorNotification(message, errorContainer) {
    var globalErrorContainerSel = '.minicart-footer .cart-error';
    var container = errorContainer || globalErrorContainerSel;
    var closeIconUrl = $(globalErrorContainerSel).data('icon-close-url');
    var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error fade show" role="alert">'
        + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
        + '<img src="' + closeIconUrl + '" alt="Close" />'
        + '</button>'
        +   message
        + '</div>';
    $(container).append(errorHtml);
}

/**
 * Updates the availability of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateAvailability(data, uuid) {
    var lineItem;
    var messages = '';

    for (var i = 0; i < data.items.length; i++) {
        if (data.items[i].UUID === uuid) {
            lineItem = data.items[i];
            break;
        }
    }

    if (lineItem != null) {
        $('.availability-' + lineItem.UUID).empty();

        if (lineItem.availability) {
            if (lineItem.availability.messages) {
                lineItem.availability.messages.forEach(function (message) {
                    messages += '<p class="line-item-attributes">' + message + '</p>';
                });
            }

            if (lineItem.availability.inStockDate) {
                messages += '<p class="line-item-attributes line-item-instock-date">'
                    + lineItem.availability.inStockDate
                    + '</p>';
            }
        }

        $('.availability-' + lineItem.UUID).html(messages);
    }
}

/**
 * Finds an element in the array that matches search parameter
 * @param {array} array - array of items to search
 * @param {function} match - function that takes an element and returns a boolean indicating if the match is made
 * @returns {Object|null} - returns an element of the array that matched the query.
 */
function findItem(array, match) { // eslint-disable-line no-unused-vars
    for (var i = 0, l = array.length; i < l; i++) {
        if (match.call(this, array[i])) {
            return array[i];
        }
    }
    return null;
}

/**
 * Updates details of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateProductDetails(data, uuid) {
    $('.card.product-info.uuid-' + uuid).replaceWith(data.renderedTemplate);
}

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#editProductModal').length !== 0) {
        $('#editProductModal').remove();
    }
    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="editProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog quick-view-dialog">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * replaces the content in the modal window for product variation to be edited.
 * @param {string} editProductUrl - url to be used to retrieve a new product model
 */
function fillModalElement(editProductUrl) {
    $('.modal-body').spinner().start();
    $.ajax({
        url: editProductUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);

            $('#editProductModal .modal-body').empty();
            $('#editProductModal .modal-body').html(parsedHtml.body);
            $('#editProductModal .modal-footer').html(parsedHtml.footer);
            $('#editProductModal .modal-header .close .sr-only').text(data.closeButtonText);
            $('#editProductModal .enter-message').text(data.enterDialogMessage);
            $('#editProductModal').modal('show');
            $('body').trigger('editproductmodal:ready');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * replace content of modal
 * @param {string} actionUrl - url to be used to remove product
 * @param {string} productID - pid
 * @param {Object} product - product object
 * @param {string} uuid - uuid
 */
function confirmDelete(actionUrl, productID, product, uuid) {
    var $deleteConfirmBtn = $('.cart-delete-confirmation-btn');
    var $name = $('.product-to-remove-name');
    var $sku = $('.product-to-remove-sku');
    var $img = $('.product-to-remove-img');
    var $modalPromo = $('.product-to-remove-badge');
    var $originalPromo = $('.uuid-' + uuid + ' .promotions .promo-badge').clone();

    if ($originalPromo.length) {
        $modalPromo.removeClass('d-none');
        $modalPromo.html($originalPromo.html());
    } else {
        $modalPromo.addClass('d-none');
        $modalPromo.empty();
    }

    $deleteConfirmBtn.data('pid', productID);
    $deleteConfirmBtn.data('action', actionUrl);
    $deleteConfirmBtn.data('uuid', uuid);

    $name.empty().append(product.productName);
    $sku.empty().append(product.sku);
    $img.attr('src', product.src);
    $img.attr('alt', product.alt);
    $img.attr('title', product.title);
}

/**
 * Updates the cart and minicart contents to reflect an empty state.
 *
 * @param {Object} data - The data object received from the AJAX call, containing basket information.
 */
function handleEmptyCartContent(data) {
    // Empty cart
    const $cart = $('.cart-content');
    if ($cart.length) {
        $cart.find('.cart-body').addClass('d-none');
        $cart.find('.cart-empty').removeClass('d-none');
    }

    // Empty mini cart
    $('.number-of-items').empty().append(data.basket.resources.numberOfItems);
    $('.minicart-quantity').empty().append(data.basket.numItems);
    $('.minicart-link').attr({
        'aria-label': data.basket.resources.minicartCountOfItems,
        title: data.basket.resources.minicartCountOfItems
    });
    $('.minicart .popover').empty();
    $('.minicart .popover').removeClass('show');
    $('body').removeClass('modal-open');
    $('html').removeClass('veiled');
}

var exportModule = function () {
    if ($('.cart-page').length) {
        quantityLimitBlocked = $('.checkout-btn').data('quantity-limit-blocked') === true;
        cartInventoryValidator.initCheckoutValidation().then(function () {
            reassertQuantityLimitBlock();
        });
    }

    if($('.cart-page').data('openDeliveryModal')) {
        setTimeout(function () { // wait for page to finish loading before trying to open the modal
            $('.user a')[0].click()
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.get('openDeliveryModal') === 'true') {
                window.history.pushState({}, '', window.location.pathname);
            }
        }, 2000);
    }

    $('body').on('click', '.remove-product', function (e) {
        e.preventDefault();

        var actionUrl = $(this).data('action');
        var productID = $(this).data('pid');
        var product = {
            productName: $(this).data('name'),
            sku: $(this).data('sku'),
            src: $(this).data('src'),
            alt: $(this).data('alt'),
            title: $(this).data('title'),
        }
        var uuid = $(this).data('uuid');
        confirmDelete(actionUrl, productID, product, uuid);
    });

    $('body').on('afterRemoveFromCart', function (e, data) {
        e.preventDefault();
        var product = {
            productName: data.name,
            sku: data.sku,
            src: data.src,
            alt: data.alt,
            title: data.title,
        }
        confirmDelete(data.actionUrl, data.productID, product, data.uuid);
    });

    $('body').on('click', '.minicart-clear-cart', function (e) {
        e.preventDefault();
        var $confirmClearBasketModal = $('.clear-cart-confirm-modal');
        var errorDeletedProductMessage = $(this).data('error-msg');
        var clearBasketUrl = $('.minicart-content').data('clear-cart-url');
        $confirmClearBasketModal.modal('show');
        $.spinner().stop();

        //prevent multiple handlers execution
        $('body').off('click', '.confirm-clear-cart');

        $('body').on('click', '.confirm-clear-cart', function () {
            var cartDeleteAllProductMessage = $(this).data('clear-msg');
            $confirmClearBasketModal.modal('hide');
            $.ajax({
                url: clearBasketUrl,
                method: 'GET',
                dataType: 'json',
                success: function(data) {
                    if (data.success) {
                        handleEmptyCartContent(data);
                        $(document).trigger('showNotificationClient', {
                            type: 'success',
                            message: cartDeleteAllProductMessage,
                            cssClass: ''
                        });
                    } else {
                        $.spinner().stop();
                    }
                },
                error: function(error) {
                    $.spinner().stop();
                    console.error(errorDeletedProductMessage, error);
                }
            });
        });
    });

    $('.optional-promo').click(function (e) {
        e.preventDefault();
        $('.promo-code-form').toggle();
    });

    $('body').on('click', '.cart-delete-confirmation-btn', function (e) {
        e.preventDefault();

        var productID = $(this).data('pid');
        var cartDeleteProductMessage = $(this).data('msg');
        var validateInventoryUrl = $('.validate-inventory-anchor').data('validate-inventory-url');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var urlParams = {
            pid: productID,
            uuid: uuid
        };

        url = appendToUrl(url, urlParams);

        $('body > .modal-backdrop').remove();

        $.spinner().start();

        $('body').trigger('cart:beforeUpdate');

        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                if (data.basket.items.length === 0) {
                    handleEmptyCartContent(data);
                } else {
                    if (data.toBeDeletedUUIDs && data.toBeDeletedUUIDs.length > 0) {
                        for (var i = 0; i < data.toBeDeletedUUIDs.length; i++) {
                            $('.uuid-' + data.toBeDeletedUUIDs[i]).remove();
                        }
                    }
                    $('.uuid-' + uuid).remove();
                    if (!data.basket.hasBonusProduct) {
                        $('.bonus-product').remove();
                    }
                    $('.coupons-and-promos').empty().append(data.basket.totals.discountsHtml);
                    cartTotals.updateCartTotals(data.basket);
                    cartTotals.updateApproachingDiscounts(data.basket.approachingDiscounts);
                    $('body').trigger('setShippingMethodSelection', data.basket);
                    validateBasket(data.basket);
                    updateQuantityLimitState(data.basket);
                    cartInventoryValidator.validateAvailabilityStatuses(data.basket);
                    cartInventoryValidator.validateCartInventory(validateInventoryUrl).then(function () {
                        reassertQuantityLimitBlock();
                    });
                }

                $('body').trigger('cart:update', data);
                $(document).trigger('showNotificationClient', {
                    type: 'success',
                    message: cartDeleteProductMessage,
                    cssClass: ''
                });

                $.spinner().stop();

                analyticsHelper.trackEvent('remove_from_cart', {
                    items: [{
                        item_id: productID
                    }]
                });
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $('body').on('change', '.quantity-form > .quantity', function () {
        var quantity = $(this).val();
        var productID = $(this).data('pid');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var validateInventoryUrl = $('.validate-inventory-anchor').data('validate-inventory-url');

        var urlParams = {
            pid: productID,
            quantity: quantity,
            uuid: uuid
        };
        url = appendToUrl(url, urlParams);

        $(this).parents('.card').spinner().start();

        $('body').trigger('cart:beforeUpdate');

        var errorContainerSel = '.item-error[data-uuid="' + uuid + '"]';
        $.ajax({
            url: url,
            type: 'get',
            context: this,
            dataType: 'json',
            success: function (data) {
                data.items.forEach(function (item) {
                    var $itemQuantitySelector = $('.quantity[data-uuid="' + item.UUID + '"]');
                    var $itemQuantitySelectorContainer = $itemQuantitySelector.parent();
                    var $itemQuantitySelectorControls = quantitySelector.getQuantitySelectorControls($itemQuantitySelectorContainer);
                    var itemQuantityOptions = item.quantityOptions;
                    var itemFinalQuantity = item.quantity;

                    if (itemQuantityOptions && itemQuantityOptions.effectiveLimit) {
                        $itemQuantitySelector.data('max-quantity', itemQuantityOptions.maxOrderQuantity);
                        $itemQuantitySelector.data('effective-limit', itemQuantityOptions.effectiveLimit);
                        $itemQuantitySelectorControls.$maxQuantity = itemQuantityOptions.maxOrderQuantity;
                        $itemQuantitySelectorControls.$effectiveLimit = Math.min(
                            itemQuantityOptions.maxOrderQuantity,
                            itemQuantityOptions.effectiveLimit
                        );
                    }

                    $itemQuantitySelector.val(itemFinalQuantity);
                    quantitySelector.updateQuantityState($itemQuantitySelectorControls, itemFinalQuantity, $itemQuantitySelectorContainer);
                    $itemQuantitySelector.data('pre-select-qty', itemFinalQuantity);
                });

                $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                cartTotals.updateCartTotals(data);
                cartTotals.updateApproachingDiscounts(data.approachingDiscounts);
                updateAvailability(data, uuid);
                validateBasket(data);
                updateQuantityLimitState(data);

                // Clear any existing errors
                var $itemErrorContainer = $(errorContainerSel);
                $itemErrorContainer.empty();

                $('body').trigger('cart:update', data);

                $.spinner().stop();
                if ($(this).parents('.product-info').hasClass('bonus-product-line-item') && $('.cart-page').length) {
                    location.reload();
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    if (err.responseJSON.availableQty) {
                        $(this).data('max-quantity', err.responseJSON.availableQty);
                    }

                    // Clear any existing errors
                    var $errorContainer = $(errorContainerSel);
                    $errorContainer.empty();

                    // $(this).closest('.card.product-info').addClass('error-state');
                    cartInventoryValidator.validateCartInventory(validateInventoryUrl).then(function () {
                        reassertQuantityLimitBlock();
                    });
                    cartInventoryValidator.disableProductCard($(this));
                    var quantitySelectorControls = quantitySelector.getQuantitySelectorControls($(this).parent());
                    quantitySelectorControls.$maxQuantity = err.responseJSON.availableQty;
                    quantitySelector.updateQuantityState(quantitySelectorControls, quantitySelectorControls.$currentQuantity, $(this).parent());

                    createErrorNotification(err.responseJSON.errorMessage, $errorContainer);
                    $.spinner().stop();
                }
            }

        });
    });

    $('.shippingMethods').change(function () {
        var url = $(this).attr('data-actionUrl');
        var urlParams = {
            methodID: $(this).find(':selected').attr('data-shipping-id')
        };
        // url = appendToUrl(url, urlParams);

        $('.totals').spinner().start();
        $('body').trigger('cart:beforeShippingMethodSelected');
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: urlParams,
            success: function (data) {
                if (data.error) {
                    window.location.href = data.redirectUrl;
                } else {
                    $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                    cartTotals.updateCartTotals(data);
                    cartTotals.updateApproachingDiscounts(data.approachingDiscounts);
                    validateBasket(data);
                }

                $('body').trigger('cart:shippingMethodSelected', data);
                $.spinner().stop();
            },
            error: function (err) {
                if (err.redirectUrl) {
                    window.location.href = err.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $('.promo-code-form').submit(function (e) {
        e.preventDefault();
        $.spinner().start();
        var $promoCodeFormControl = $('.promo-code-form .form-control');
        $('.coupon-missing-error').hide();
        $('.coupon-error-message').empty();
        if (!$('.coupon-code-field').val()) {
            $promoCodeFormControl.addClass('is-invalid');
            $promoCodeFormControl.attr('aria-describedby', 'missingCouponCode');
            $('.coupon-error-message').empty().append($promoCodeFormControl.data('empty'));
            $.spinner().stop();
            return false;
        }
        var $form = $('.promo-code-form');
        $promoCodeFormControl.removeClass('is-invalid');
        $('.coupon-error-message').empty();
        $('body').trigger('promotion:beforeUpdate');

        $.ajax({
            url: $form.attr('action'),
            type: 'GET',
            dataType: 'json',
            data: $form.serialize(),
            success: function (data) {
                if (data.error) {
                    $promoCodeFormControl.addClass('is-invalid');
                    $promoCodeFormControl.attr('aria-describedby', 'invalidCouponCode');
                    $('.coupon-error-message').empty().append(data.errorMessage);
                    $('body').trigger('promotion:error', data);
                } else {
                    $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                    cartTotals.updateCartTotals(data);
                    cartTotals.updateApproachingDiscounts(data.approachingDiscounts);
                    validateBasket(data);
                    $('body').trigger('promotion:success', data);
                }
                $('.coupon-code-field').val('');
                $.spinner().stop();
            },
            error: function (err) {
                $('body').trigger('promotion:error', err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.errorMessage);
                    $.spinner().stop();
                }
            }
        });
        return false;
    });

    $('body').on('click', '.remove-coupon', function (e) {
        e.preventDefault();

        var couponCode = $(this).data('code');
        var uuid = $(this).data('uuid');
        var $deleteConfirmBtn = $('.delete-coupon-confirmation-btn');
        var $productToRemoveSpan = $('.coupon-to-remove');

        $deleteConfirmBtn.data('uuid', uuid);
        $deleteConfirmBtn.data('code', couponCode);

        $productToRemoveSpan.empty().append(couponCode);
    });

    $('body').on('click', '.delete-coupon-confirmation-btn', function (e) {
        e.preventDefault();

        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var couponCode = $(this).data('code');
        var urlParams = {
            code: couponCode,
            uuid: uuid
        };

        url = appendToUrl(url, urlParams);

        $('body > .modal-backdrop').remove();

        $.spinner().start();
        $('body').trigger('promotion:beforeUpdate');
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                $('.coupon-uuid-' + uuid).remove();
                cartTotals.updateCartTotals(data);
                cartTotals.updateApproachingDiscounts(data.approachingDiscounts);
                validateBasket(data);
                $.spinner().stop();
                $('body').trigger('promotion:success', data);
            },
            error: function (err) {
                $('body').trigger('promotion:error', err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });
    $('body').on('click', '.cart-page .bonus-product-button', function () {
        $.spinner().start();
        $(this).addClass('launched-modal');
        $.ajax({
            url: $(this).data('url'),
            method: 'GET',
            dataType: 'json',
            success: function (data) {
                base.methods.editBonusProducts(data);
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });

    $('body').on('hidden.bs.modal', '#chooseBonusProductModal', function () {
        $('#chooseBonusProductModal').remove();
        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open');

        if ($('.cart-page').length) {
            $('.launched-modal .btn-outline-primary').trigger('focus');
            $('.launched-modal').removeClass('launched-modal');
        } else {
            $('.product-detail .add-to-cart').focus();
        }
    });

    $('body').on('click', '.cart-page .product-edit .edit, .cart-page .bundle-edit .edit', function (e) {
        e.preventDefault();

        var editProductUrl = $(this).attr('href');
        getModalHtmlElement();
        fillModalElement(editProductUrl);
    });

    $('body').on('shown.bs.modal', '#editProductModal', function () {
        $('#editProductModal').siblings().attr('aria-hidden', 'true');
        $('#editProductModal .close').focus();
    });

    $('body').on('hidden.bs.modal', '#editProductModal', function () {
        $('#editProductModal').siblings().attr('aria-hidden', 'false');
    });

    $('body').on('keydown', '#editProductModal', function (e) {
        var focusParams = {
            event: e,
            containerSelector: '#editProductModal',
            firstElementSelector: '.close',
            lastElementSelector: '.update-cart-product-global',
            nextToLastElementSelector: '.modal-footer .quantity-select'
        };
        focusHelper.setTabNextFocus(focusParams);
    });

    $('body').on('product:updateAddToCart', function (e, response) {
        // update global add to cart (single products, bundles)
        var dialog = $(response.$productContainer)
            .closest('.quick-view-dialog');

        $('.update-cart-product-global', dialog).attr(
            'disabled',
            !$('.global-availability', dialog).data('ready-to-order')
            || !$('.global-availability', dialog).data('available')
        );
    });

    $('body').on('product:updateAvailability', function (e, response) {
        // bundle individual products
        $('.product-availability', response.$productContainer)
            .data('ready-to-order', response.product.readyToOrder)
            .data('available', response.product.available)
            .find('.availability-msg')
            .empty()
            .html(response.message);

        var dialog = $(response.$productContainer)
            .closest('.quick-view-dialog');

        if ($('.product-availability', dialog).length) {
            // bundle all products
            var allAvailable = $('.product-availability', dialog).toArray()
                .every(function (item) { return $(item).data('available'); });

            var allReady = $('.product-availability', dialog).toArray()
                .every(function (item) { return $(item).data('ready-to-order'); });

            $('.global-availability', dialog)
                .data('ready-to-order', allReady)
                .data('available', allAvailable);

            $('.global-availability .availability-msg', dialog).empty()
                .html(allReady ? response.message : response.resources.info_selectforstock);
        } else {
            // single product
            $('.global-availability', dialog)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .find('.availability-msg')
                .empty()
                .html(response.message);
        }
    });

    $('body').on('product:afterAttributeSelect', function (e, response) {
        if ($('.modal.show .product-quickview .bundle-items').length) {
            $('.modal.show').find(response.container).data('pid', response.data.product.id);
            $('.modal.show').find(response.container).find('.product-id').text(response.data.product.id);
        } else {
            $('.modal.show .product-quickview').data('pid', response.data.product.id);
        }
    });

    $('body').on('change', '.quantity-select', function () {
        var selectedQuantity = $(this).val();
        $('.modal.show .update-cart-url').data('selected-quantity', selectedQuantity);
    });

    $('body').on('change', '.options-select', function () {
        var selectedOptionValueId = $(this).children('option:selected').data('value-id');
        $('.modal.show .update-cart-url').data('selected-option', selectedOptionValueId);
    });

    $('body').on('click', '.update-cart-product-global', function (e) {
        e.preventDefault();

        var updateProductUrl = $(this).closest('.cart-and-ipay').find('.update-cart-url').val();
        var selectedQuantity = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('selected-quantity');
        var selectedOptionValueId = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('selected-option');
        var uuid = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('uuid');

        var form = {
            uuid: uuid,
            pid: base.getPidValue($(this)),
            quantity: selectedQuantity,
            selectedOptionValueId: selectedOptionValueId
        };

        $(this).parents('.card').spinner().start();

        $('body').trigger('cart:beforeUpdate');

        if (updateProductUrl) {
            $.ajax({
                url: updateProductUrl,
                type: 'post',
                context: this,
                data: form,
                dataType: 'json',
                success: function (data) {
                    $('#editProductModal').modal('hide');

                    $('.coupons-and-promos').empty().append(data.cartModel.totals.discountsHtml);
                    cartTotals.updateCartTotals(data.cartModel);
                    cartTotals.updateApproachingDiscounts(data.cartModel.approachingDiscounts);
                    updateAvailability(data.cartModel, uuid);
                    updateProductDetails(data, uuid);

                    if (data.uuidToBeDeleted) {
                        $('.uuid-' + data.uuidToBeDeleted).remove();
                    }

                    validateBasket(data.cartModel);

                    $('body').trigger('cart:update', data);

                    $.spinner().stop();
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err.responseJSON.errorMessage);
                        $.spinner().stop();
                    }
                }
            });
        }
    });

    base.selectAttribute();
    base.colorAttribute();
    base.removeBonusProduct();
    base.selectBonusProduct();
    base.enableBonusProductSelection();
    base.showMoreBonusProducts();
    base.addBonusProductsToCart();
    base.focusChooseBonusProductModal();
    base.trapChooseBonusProductModalFocus();
    base.onClosingChooseBonusProductModal();
};

module.exports = exportModule;
